import React from 'react'
import classNames from 'classnames'

import { Tooltip } from '../Tooltip'

import './InputMask.scoped.sass'
import commonsService from '@/services/commons.service'
import { HelperMessage } from '../HelperMessage'

export function InputMask (props) {
  const {
    label,
    autocorrect,
    autocomplete,
    spellcheck,
    autocapitalize,
    type = 'text',
    placeholder,
    inputName,
    value,
    disabled,
    required,
    isBorderDisable,
    maxLength,
    showError = true,
    errorMessage = '',
    infoMessage = '',
    onInput,
    size = '',
    helperIcon,
    helperMessage = '',
    helperTitle = '',
    onKeyPress,
    classType,
    hasLabel = true,
  } = props

  const isEmpty = !value
  const _showError = () => {
    return errorMessage && showError
  }
  const _showInfo = () => {
    return !_showError() && infoMessage
  }
  const _onBlur = () => {}
  const _onFocus = (e) => { e.preventDefault() }
  const _onInput = (e) => {
    if (onInput) onInput(e.target.value)
  }
  return <div className={classNames(`input ${size}`, {
    '_is-empty': isEmpty,
    '_is-invalid': _showError(),
    '_is-disabled': disabled,
    '_is-required': required,
    '_is-border-disable': isBorderDisable
    // '_show-error': show_error,
  })} >
    {_showInfo()
      ? <div className="input-bottom info">
        <img src="/assets/icons/info-icon.svg" />
        <span>{infoMessage}</span>
      </div>
      : ''}
    {_showError()
      ? <div className="input-bottom error">
        <img src="/assets/icons/error-icon.svg" />
        <span>{errorMessage}</span>
      </div>
      : ''
    }
    <input
      required={required}
      disabled={disabled || null}
      name={inputName}
      type={type}
      value={value}
      placeholder={placeholder}
      autoComplete={autocomplete === true ? 'on' : (autocomplete || 'nope')}
      autoCorrect={autocorrect ? 'on' : 'off'}
      autoCapitalize={autocapitalize === true ? 'on' : (autocapitalize || 'off')}
      spellCheck={spellcheck}
      maxLength={maxLength || null}
      aria-label={label}
      onBlur={_onBlur}
      onFocus={_onFocus}
      onChange={_onInput}
      className={classType}
      onKeyPress={onKeyPress}
    />
    {hasLabel && <label style={{ display: 'flex' }}>{label} {helperMessage && (<div className='helper-icon-container'>
      { commonsService.isMobile() ? <HelperMessage title={helperTitle} text={helperMessage}/> : <Tooltip text={helperMessage} size='large'/> }
    </div>
    )}
    </label> }
    { helperIcon && <helperIcon/> }
  </div>
}
